<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'DictionaryList'
}
</script>

<style scoped>

</style>
